















site = require('@/../config/site')

export default {
  name: 'store-links'

  data: -> 
    playStore: 
      image: require '@/assets/images/lucre-games-google-play-icon.png'
      url: site.game.playStoreUrl

    appStore: 
      image: require '@/assets/images/lucre-games-app-store-icon.png'
      url: site.game.appStoreUrl


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StoreLinks.vue